import { DeleteOutlined, FormOutlined, RollbackOutlined } from "@ant-design/icons";
import { useFormik } from "formik";
import { useEffect, useState } from "react";

// Internal Imports
import ButtonGrid from "../../../common/components/ButtonGrid/ButtonGrid";
import MarginInput from "../../../common/components/MarginInput/MarginInput";
import SelectBox from "../../../common/components/SelectBox/SelectBox";
import { COLORS } from "../../../common/constants/colors";
import GroupRow from "../../../common/components/GroupRow/GroupRow";
import { Mode } from "../../../common/types/AllTypes";
import { useForm } from "../../../contexts/form";
import useListAttribute from "../../../hooks/useListAttribute";
import { useListDepartmentByUer } from "../../../hooks/useListDepartment";
import IColumn from "../../../interfaces/IColumn";
import { IListAttribute } from "../../../interfaces/IListado";
import globalStyle from "../../../common/styles/globalStyle.module.css";
import Paint from "../../../common/components/Paint/Paint";
import OutLineButton from "../../../common/components/OutLineButton/OutLineButton";
import DetailTable from "../../../common/components/DetailTable/DetailTable";
import Modal from "../../../common/components/Modal/Modal";
import AddUpdateAttribute from "../../Atributos/AddUpdateAttribute";
import { IAttribute, TypeAttribute } from "../../../interfaces/IAttribute";
import { returnOrdenSelection } from "../../../common/constants/Utilities";


interface Props {
    setCanGoNext: React.Dispatch<React.SetStateAction<boolean>>;
    setCanGoBack: React.Dispatch<React.SetStateAction<boolean>>;
    mode: Mode;
}


const StepTwo = ({ setCanGoNext, setCanGoBack, mode }: Props) => {

    // States
    const { listAttribute, loadingAttr, setListAttribute } = useListAttribute();
    const { setListBaseForm, listBaseForm } = useForm();
    const [detailUpdate, setDetailUpdate] = useState<IListAttribute>();
    const [listAttributeList, setListAttributeList] = useState<IListAttribute[]>([]);

    const [attributeView, setAttributeView] = useState<IAttribute>();
    const [visibleDetailModal, setVisibleDetailModal] = useState<boolean>(false);

    // Modal ShortCut AddAttr
    const { listDepartment, loadingDeparment } = useListDepartmentByUer();
    const [visibleModal, setVisibleModal] = useState<boolean>(false);

    // Const
    const columns: IColumn[] = [
        {
            title: 'Atributo',
            dataIndex: '',
            render: (detail: IListAttribute) => <nav>{listAttribute.find(x => x.atributoGUID === detail.atributoGUID)?.nombre}</nav>
        },
        {
            title: 'Orden',
            dataIndex: 'orden',
        },

        {
            title: "",
            dataIndex: "",
            render: (detail: IListAttribute) => (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {listAttribute.find(x => x.atributoGUID === detail.atributoGUID)?.atributoTipo === TypeAttribute.Detalle &&
                        <>
                            <ButtonGrid color={COLORS.black_text_color4} active={!detailUpdate} icon={<i className="fa-solid fa-eye"></i>} method={() => seeDetail(detail)} />
                            <nav>&nbsp;&nbsp;</nav>
                        </>
                    }
                    <ButtonGrid color={COLORS.black_text_color4} active={detailUpdate?.atributoGUID !== detail.atributoGUID && !!detailUpdate ? false : true} icon={detailUpdate?.atributoGUID === detail.atributoGUID ? <RollbackOutlined /> : <FormOutlined />} method={() => selectDetail(detail)} />
                    <nav>&nbsp;&nbsp;</nav>
                    <ButtonGrid color={COLORS.black_text_color4} active={!detailUpdate} icon={<DeleteOutlined />} method={() => removeDetail(detail.atributoGUID)} />
                </div>
            )
        }
    ];

    // Methods
    const seeDetail = (detail: IListAttribute) => {
        let att = listAttribute.find(x => x.atributoGUID === detail.atributoGUID)!;
        setAttributeView(att);
        setVisibleDetailModal(true);
    }

    const validations = (values: any) => {
        const errors: any = {};

        if (!values.atributoGUID) {
            errors.atributoGUID = "Requerido";
        }

        if (!values.orden) {
            errors.orden = "Requerido";
        }

        if (!values.usarParaFiltrarEnUsuario) {
            errors.usarParaFiltrarEnUsuario = "Requerido";
        }

        if (values.usarParaFiltrarEnUsuario == "true") {
            if (!values.esObligatorioUsarParaFiltrarEnUsuario) {
                errors.esObligatorioUsarParaFiltrarEnUsuario = "Requerido";
            }
        }

        return errors;
    }

    const clearForm = () => {
        ListBaseFormik.setValues({
            atributoGUID: "",
            orden: "",
            usarParaFiltrarEnUsuario: "",
            esObligatorioUsarParaFiltrarEnUsuario: ""
        })
    }

    const addDetail = () => {
        const newAttr: IListAttribute = {
            listadoAtributoID: 0,
            listadoID: listBaseForm!.listadoID,
            atributoGUID: ListBaseFormik.values.atributoGUID,
            usarParaFiltrarEnUsuario: ListBaseFormik.values.usarParaFiltrarEnUsuario === "true" ? true : false,
            esObligatorioUsarParaFiltrarEnUsuario: ListBaseFormik.values.esObligatorioUsarParaFiltrarEnUsuario === "true" ? true : false,
            orden: parseInt(ListBaseFormik.values.orden)
        }

        let listInternal = listBaseForm!.listadoAtributo!;
        listInternal.push(newAttr);

        setListBaseForm({ ...listBaseForm!, listadoAtributo: listInternal! });
        clearForm();
    }

    const selectDetail = (attribute: IListAttribute) => {
        if (!!!detailUpdate) {
            setDetailUpdate(attribute);

            ListBaseFormik.setValues({
                atributoGUID: attribute.atributoGUID,
                orden: attribute.orden.toString(),
                usarParaFiltrarEnUsuario: attribute.usarParaFiltrarEnUsuario.toString(),
                esObligatorioUsarParaFiltrarEnUsuario: attribute.esObligatorioUsarParaFiltrarEnUsuario.toString()
            })

        } else {
            setDetailUpdate(undefined);
            clearForm();
        }
    }

    const updateDetail = () => {
        let internal: IListAttribute = {
            listadoAtributoID: detailUpdate?.listadoAtributoID!,
            listadoID: detailUpdate!.listadoID,
            atributoGUID: ListBaseFormik.values.atributoGUID,
            usarParaFiltrarEnUsuario: ListBaseFormik.values.usarParaFiltrarEnUsuario === "true" ? true : false,
            esObligatorioUsarParaFiltrarEnUsuario: ListBaseFormik.values.esObligatorioUsarParaFiltrarEnUsuario === "true" ? true : false,
            orden: parseInt(ListBaseFormik.values.orden)
        }

        let listInternal = listBaseForm!.listadoAtributo!;
        let index = listInternal.findIndex(x => x.atributoGUID === detailUpdate!.atributoGUID);

        listInternal[index] = internal!;

        setListBaseForm({ ...listBaseForm!, listadoAtributo: [...listInternal!] });

        // Finally
        setDetailUpdate(undefined);
        clearForm();
    }

    const removeDetail = (attrGUID: string) => {
        const listInternal = listBaseForm!.listadoAtributo!.filter(attr => attr.atributoGUID !== attrGUID);
        setListBaseForm({ ...listBaseForm!, listadoAtributo: [...listInternal!] });
    }


    // Form
    const ListBaseFormik = useFormik({
        initialValues: { atributoGUID: "", orden: "", usarParaFiltrarEnUsuario: "", esObligatorioUsarParaFiltrarEnUsuario: "" },
        validate: validations,
        onSubmit: (values: any) => !!detailUpdate ? updateDetail() : addDetail(),
    });

    // Effects
    useEffect(() => {
        if (!!listBaseForm && listBaseForm?.listadoAtributo!.length > 0) {
            setListAttributeList([...listBaseForm?.listadoAtributo!]);
        } else {
            setListAttributeList([]);
        }
    }, [listBaseForm]);


    useEffect(() => {
        if (!!detailUpdate) {
            setCanGoNext(false);
            setCanGoBack(false);
        } else {
            setCanGoNext(true);
            setCanGoBack(true);
        }
    }, [detailUpdate]);


    return (
        <div style={{ marginTop: 20 }}>
            <GroupRow>
                <MarginInput width="45%">
                    <label>Atributo:</label>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
                        <SelectBox
                            value={ListBaseFormik.values.atributoGUID}
                            placeholder={"Atributo"}
                            disabled={false}
                            allowClear={false}
                            loading={loadingAttr}
                            onChange={(value: string) => ListBaseFormik.setFieldValue("atributoGUID", value)}
                            options={listAttribute.filter(attr => attr.departamentoGUID === listBaseForm?.departamentoGUID && (!listBaseForm!.listadoAtributo!.map(x => x.atributoGUID).includes(attr.atributoGUID!) || attr.atributoGUID === detailUpdate?.atributoGUID)).map(attr => ({ key: attr.nombre, value: attr.atributoGUID, text: attr.nombre }))}
                            backgroundColor={COLORS.white_color2(1)}
                            borderColor={COLORS.black_text_color3}
                            textColor={COLORS.black_text_color1}
                        />
                        <nav className="addShortCut" onClick={() => setVisibleModal(true)}><i className="fa-solid fa-plus"></i></nav>
                    </div>
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ListBaseFormik.errors.atributoGUID && ListBaseFormik.errors.atributoGUID}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Orden:</label>
                    <SelectBox
                        value={ListBaseFormik.values.orden}
                        placeholder={"Orden"}
                        disabled={false}
                        allowClear={false}
                        loading={loadingAttr}
                        onChange={(value: string) => ListBaseFormik.setFieldValue("orden", value)}
                        options={returnOrdenSelection(detailUpdate?.orden.toString() || '', listBaseForm?.listadoAtributo)}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ListBaseFormik.errors.orden && ListBaseFormik.errors.orden}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="45%">
                    <label>¿Usar para filtro de usuario?:</label>
                    <SelectBox
                        value={ListBaseFormik.values.usarParaFiltrarEnUsuario}
                        placeholder={"¿Usar para filtro?"}
                        disabled={false}
                        allowClear={false}
                        loading={false}
                        onChange={(value: string) => ListBaseFormik.setValues({ ...ListBaseFormik.values, usarParaFiltrarEnUsuario: value, esObligatorioUsarParaFiltrarEnUsuario: "" })}
                        options={[{ key: 'tempSi', value: 'true', text: 'Si' }, { key: 'tempNo', value: 'false', text: 'No' }]}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ListBaseFormik.errors.usarParaFiltrarEnUsuario && ListBaseFormik.errors.usarParaFiltrarEnUsuario}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Requerido:</label>
                    <SelectBox
                        value={ListBaseFormik.values.esObligatorioUsarParaFiltrarEnUsuario}
                        placeholder={"¿Requerido?"}
                        disabled={ListBaseFormik.values.usarParaFiltrarEnUsuario !== "true"}
                        allowClear={false}
                        loading={false}
                        onChange={(value: string) => ListBaseFormik.setFieldValue("esObligatorioUsarParaFiltrarEnUsuario", value)}
                        options={[{ key: 'tempSi', value: 'true', text: 'Si' }, { key: 'tempNo', value: 'false', text: 'No' }]}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ListBaseFormik.errors.esObligatorioUsarParaFiltrarEnUsuario && ListBaseFormik.errors.esObligatorioUsarParaFiltrarEnUsuario}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <div>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
                    <MarginInput width="40%">
                        <OutLineButton color={!!detailUpdate ? COLORS.white_color1 : COLORS.blue_active} backgroundColor={!!detailUpdate ? COLORS.blue_main(1) : COLORS.transparent_color1} text={!!detailUpdate ? "Modificar Attributo" : "Añadir Attributo"} method={ListBaseFormik.handleSubmit} />
                    </MarginInput>
                </div>
                <DetailTable
                    props={{ rowKey: (record: any) => record.atributoGUID }}
                    dataSource={listAttributeList}
                    columns={columns}
                    loading={false}
                    paginationActive={!detailUpdate}
                />
            </div>


            <Modal props={{ style: { top: '-45px' } }} width={"50%"} title={<nav className="modal_title"> Crear <Paint color={COLORS.blue_main(1)}>Atributo</Paint></nav>} visible={visibleModal} setVisible={setVisibleModal} askBeforeClose={true}>
                <AddUpdateAttribute defaultDepartmentGUID={listBaseForm?.departamentoGUID} setDataList={setListAttribute} dataList={listAttribute} attribute={undefined} mode={'Add'} setAttributeUpdate={undefined} setAddUpdateModal={setVisibleModal} listDepartment={listDepartment} loadingDeparment={loadingDeparment} />
            </Modal>

            <Modal props={{ style: { top: '-45px' } }} width={"30%"} title={<nav className="modal_title"> Posibles <Paint color={COLORS.blue_main(1)}>Valores</Paint></nav>} visible={visibleDetailModal} setVisible={setVisibleDetailModal} askBeforeClose={false}>
                <div style={{ textAlign: 'center' }}>
                    {attributeView?.atributoDetalle.map(x => (
                        <li className="stepTow_li" key={x.atributoValor}>{x.atributoValor}</li>
                    ))
                    }
                </div>
            </Modal>

        </div>

    );

}

export default StepTwo;